import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ErrorCodesEnum } from '~/core/services/error-code/enums/codes.enum';
import { ErrorCodeService } from '~/core/services/error-code/error-code.service';
import { OrganizerSharedAbstractGuard } from '~/organizer/shared/guards/guard.abstract';
import { OrganizerSharedOrganizationService } from '~/organizer/shared/services/organization/organization.service';

@Injectable({
  providedIn: 'root',
})
class PermissionsService extends OrganizerSharedAbstractGuard {
  protected readonly errorCode =
    ErrorCodesEnum.OrganizerSharedGetOrganizationByQueryId;

  constructor(
    private readonly organizationService: OrganizerSharedOrganizationService,
    protected readonly errorCodeService: ErrorCodeService,
    protected readonly router: Router
  ) {
    super(errorCodeService, router);
  }

  public canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | true {
    const organizationId = route.queryParams.organizationId;

    if (organizationId === undefined) {
      return true;
    }

    return this.organizationService.getOrganizationById(organizationId).pipe(
      map((organization) => {
        this.organizationService.organization = organization;

        return true;
      }),
      catchError(() => this.catchError())
    );
  }
}

export const OrganizerSharedGetOrganizationByQueryIdGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot
): Observable<boolean> | true => {
  return inject(PermissionsService).canActivate(next);
};
